<template src="./index.html"></template>

<script>

export default {
  data: function () {
    return {
      tableData: [
        {
          xuh: 1,
          faphm: 62366798,
          kaiprq: "2019-09-29",
          shangpmc: "*软件*速元发票数字化信息管理平台软件[简称：速元发票管理平台]V3.0",
          qbxse: "88495.58",
          qbxxse: "11504.42",
          rjcpxse: "88495.58",
          rjcpxxse: "11504.42",
          cpje: "",
          hth: ""
        },
        {
          xuh: "合计",
          qbxse: "88495.58",
          qbxxse: "11504.42",
          rjcpxse: "88495.58",
          rjcpxxse: "11504.42",
        }
      ],
      data: {
        suosq: "2019年09期",
        companyName: "上海速元信息技术有限公司",
        writeTime: "2019年10月18日",
        writeInstructions: "1、填写“软件产品销售额”和“软件产品销项税额”二栏须同“合同对应软件产品金额”和“对应合同号码”二栏相对应；\r\n2、使用“普通发票”填制“销售额”一栏，“销售额”＝“销售收入”栏数据÷1.17；\r\n3、使用“普通发票”填制“销项税额”一栏，“销项税额”＝“销售额”栏数据×17%；\r\n4、软件产品销售额含纳税人销售软件产品并随同销售一并收取的软件安装费、维护费、培训费等收入（指在同一张发票上收取的，并按规定缴纳增值税的)。\r\n5、此表一式一份随同《软件产品增值税即征即退申请表》一并上报。",
      }
    };
  },
  created() {
  },
  mounted() {
  },
  components: {},
  methods: {
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
